<script setup lang="ts">
import { Components } from '@/api/generated/api';
import { SchoolClassType } from '@/api/generated/api.enum';
import SchoolClassGroupIcon from '@/assets/icons/SchoolClassGroupIcon.vue';
import { getClassName } from 'common/utils/format.utils';

/** a container's name for lists that mix classes and groups: a group is marked, a class is not */
defineProps<{
  schoolClass: { name: string; nickname?: string | null; type?: Components.Schemas.SchoolClassType };
}>();
</script>

<template>
  <span class="inline-flex min-w-0 items-center gap-xs">
    <span class="min-w-0 break-words hyphens-auto">
      <slot>{{ getClassName(schoolClass) }}</slot>
    </span>
    <SchoolClassGroupIcon v-if="schoolClass.type === SchoolClassType.group" class="size-4 shrink-0 text-secondary" />
  </span>
</template>
